var React = require('react');

function ArrowAltDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288,56V256H159.88V56a24,24,0,0,1,24-24H264A24,24,0,0,1,288,56Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M408.93,297,241,473a24.09,24.09,0,0,1-34,0L39.07,297c-15.11-15.09-4.4-41,17-41H391.93C413.35,256,424,281.76,408.93,297Z","className":"fa-primary","key":2})]);
}

ArrowAltDown.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltDown;

ArrowAltDown.default = ArrowAltDown;
